module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_5-c6b556720527a1522d2211118d253970.jpg";